<template>
  <div>
    <div class="page">
      <b-row class="not-print">
        <b-col class="d-flex">
          <b-btn
            class="mr-3"
            @click="setLayout('thermal')"
            :variant="layout == 'thermal' ? 'primary' : 'outline-primary'"
            size="sm"
            pill
            >Impressão Térmica</b-btn
          >
          <b-btn
            @click="setLayout('common')"
            :variant="layout == 'common' ? 'primary' : 'outline-primary'"
            size="sm"
            pill
            >Impressão Comum</b-btn
          >
          <button class="btn btn-primary ml-auto" @click="print">
            Imprimir
          </button>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <component
            style="page-break-after: always"
            :is="layout"
            :bill="bill"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import thermal from "@/components/billReceiveble/sections/BillPromissoryThermalPrint.vue";
import common from "@/components/billReceiveble/sections/BillPromissoryCommonPrint.vue";
export default {
  components: { common, thermal },
  data: function () {
    return {
      layout: "common",
      bill: {
         person: {},
        company: {address:{}},
        
       },
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    print_layout() {
      return this.$store.getters["print/getPrintLayout"];
    },
  },

  created() {
    this.$store.commit("pageHasLoaded");

    if (this.$route.params.id) {
      axios
        .get(
          `${process.env.BASE_URL}erp/billReceiveble/billReceiveble/${this.$route.params.id}`
        )
        .then((response) => {
          this.bill = response.data.bill;

          this.$store.commit("pageHasLoaded");
          this.layout = this.print_layout;
        })
        .catch((error) => {
          this.error = error;
        });
    } else {
      this.$store.commit("pageHasLoaded");
    }
  },

  methods: {
    print() {
      window.print();
    },
    setLayout(layout) {
      this.layout = layout;
      this.$store.dispatch("print/setPrintLayout", layout);
    },
  },
};
</script>

<style scoped>
.page {
  margin: 10px;
}
@media print {
  .not-print {
    display: none;
  }
  .page {
    margin: initial;
  }
}
</style>
